import { toast } from "react-toastify";
import { setWelcomeToast } from "../slices/welcomeToaster/action";

import "react-toastify/dist/ReactToastify.css";

export const handleLoginSuccess = (
  response,
  dispatch,
  setLoading,
  navigate,
) => {
  const {
    accessToken,
    refreshToken,
    userId,
    roleName,
    operatorId,
    permissions,
    userName,
    operatorName,
    customerId,
  } = response;

  const jsonString = JSON.stringify(permissions);

  localStorage.setItem("token", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("userId", userId);
  localStorage.setItem("roleName", roleName);
  localStorage.setItem("operatorId", operatorId);
  localStorage.setItem("permissionss", jsonString);
  localStorage.setItem("userName", userName);
  localStorage.setItem("operatorName", operatorName);

  if (roleName === "Customer") {
    localStorage.setItem("customerId", customerId);
  }

  if (roleName === "ISPPartnerAdmin") {
    localStorage.setItem("PartnerId", operatorId.split("/").pop());
  }

  localStorage.setItem("dateFormat", "DD MMM YYYY");

  if (response && Array.isArray(response.permissions)) {
    // Check Report permission
    const hasReportPermission = response.permissions.some(
      (permission) =>
        permission?.resourceName === "reports" ||
        permission?.module === "Reports",
    );

    const hasDashboardPermission = response.permissions.some(
      (permission) =>
        permission?.resourceName === "dashboard" ||
        permission?.module === "Dashboard",
    );

    const hasCustomerPermission = response.permissions.some(
      (permission) =>
        permission?.resourceName === "customer" ||
        permission?.module === "Customer",
    );

    const hasUserPermission = response.permissions.some(
      (permission) =>
        permission?.resourceName === "userManagement" ||
        (permission?.module === "Administration" &&
          permission?.submodules?.some(
            (sub) => sub?.submodule === "userManagement",
          )),
    );

    setLoading(false);

    // Report permission → Report page
    // No report permission → Dashboard
  if(roleName === "EVPartnerAdmin"){
      navigate("/finance-report");
    }
   else if (hasReportPermission) {
      navigate("/report");
    } else if (hasDashboardPermission) {
      navigate("/dashboard");
    } else if (hasCustomerPermission) {
      navigate("/customer");
    } else if (
      (roleName === "SGCExecutiveUser" ||
        roleName === "SGCPowerUser" ||
        roleName === "SGCOperationsUser") &&
      hasUserPermission
    ) {
      navigate("/user");
    } else if (roleName === "systemUser") {
      navigate("/operator-listing");
    } else if(roleName === "CMSPartnerAdmin"){
      navigate("/offers");
    } else {
      navigate("/dashboard");
    }
  } else {
    setLoading(false);
    navigate("/dashboard");
  }

  dispatch(setWelcomeToast(true));
};

export const handleLoginFailure = (error, setLoading) => {
  setLoading(false);
  toast.error(error);
};
